/* Shopify's Ajax cart sections can fall back to source-language option values.
   Keep the shopper-facing cart drawer in the active storefront language. */
(() => {
  const englishStorefront = () => /^en(?:-|$)/i.test(document.documentElement.lang || '');
  const frenchStorefront = () => /^fr(?:-|$)/i.test(document.documentElement.lang || '');
  const italianStorefront = () => /^it(?:-|$)/i.test(document.documentElement.lang || '');
  const spanishStorefront = () => /^es(?:-|$)/i.test(document.documentElement.lang || '');

  const exactEnglish = {
    'Color': 'Color',
    'Talla': 'Size',
    'Número de letras': 'Number of letters',
    'Número de piedras de nacimiento': 'Number of birthstones',
    'Número de iniciales': 'Number of initials',
    'Letra': 'Letter',
    'Inicial': 'Initial',
    'Inicial izquierda': 'Left initial',
    'Inicial derecha': 'Right initial',
    'Piedra izquierda': 'Left birthstone',
    'Piedra derecha': 'Right birthstone',
    'Piedra de nacimiento': 'Birthstone',
    'Oro': 'Gold',
    'Plata': 'Silver',
    'Oro rosa': 'Rose gold',
    'Enero': 'January',
    'Febrero': 'February',
    'Marzo': 'March',
    'Abril': 'April',
    'Mayo': 'May',
    'Junio': 'June',
    'Julio': 'July',
    'Agosto': 'August',
    'Septiembre': 'September',
    'Octubre': 'October',
    'Noviembre': 'November',
    'Diciembre': 'December',
    'Anillo Veria': 'VERIA RING',
    'ANILLO VERIA': 'VERIA RING',
    'Collar de Letra Bubble': 'BUBBLE LETTER NECKLACE',
    'COLLAR DE LETRA BUBBLE': 'BUBBLE LETTER NECKLACE',
    'Pulsera Veria': 'VERIA BRACELET',
    'PULSERA VERIA': 'VERIA BRACELET',
    'Collar Veria': 'VERIA NECKLACE',
    'COLLAR VERIA': 'VERIA NECKLACE',
    'Anillo Alma': 'ALMA RING',
    'ANILLO ALMA': 'ALMA RING',
    'Anillo Carla': 'CARLA RING',
    'ANILLO CARLA': 'CARLA RING',
    'Anillo Cloe': 'CLOE RING',
    'ANILLO CLOE': 'CLOE RING',
    'Pulsera Duo': 'DUO BRACELET',
    'PULSERA DUO': 'DUO BRACELET',
    'Caja de regalo de lujo': 'Luxury Gift Box',
    'CAJA DE REGALO DE LUJO': 'Luxury Gift Box'
  };

  const exactSpanish = {
    'Color': 'Color',
    'Left initial': 'Inicial izquierda',
    'Right initial': 'Inicial derecha',
    'Gold': 'Oro',
    'Silver': 'Plata',
    'Rose gold': 'Oro rosa'
  };

  const exactItalian = {
    'Color': 'Colore',
    'Talla': 'Taglia',
    'Size': 'Taglia',
    'Número de letras': 'Numero di lettere',
    'Number of letters': 'Numero di lettere',
    'Número de piedras de nacimiento': 'Numero di pietre di nascita',
    'Number of birthstones': 'Numero di pietre di nascita',
    'Número de iniciales': 'Numero di iniziali',
    'Number of initials': 'Numero di iniziali',
    'Número de medallas': 'Numero di ciondoli',
    'Number of Charms': 'Numero di ciondoli',
    'Letra': 'Lettera',
    'Letter': 'Lettera',
    'Inicial': 'Iniziale',
    'Initial': 'Iniziale',
    'Medalla': 'Ciondolo',
    'Charm': 'Ciondolo',
    'Inicial izquierda': 'Iniziale sinistra',
    'Left initial': 'Iniziale sinistra',
    'Inicial derecha': 'Iniziale destra',
    'Right initial': 'Iniziale destra',
    'Piedra izquierda': 'Pietra di nascita sinistra',
    'Piedra de nacimiento izquierda': 'Pietra di nascita sinistra',
    'Left birthstone': 'Pietra di nascita sinistra',
    'Piedra derecha': 'Pietra di nascita destra',
    'Piedra de nacimiento derecha': 'Pietra di nascita destra',
    'Right birthstone': 'Pietra di nascita destra',
    'Piedra de nacimiento': 'Pietra di nascita',
    'Birthstone': 'Pietra di nascita',
    'Oro': 'Oro',
    'Gold': 'Oro',
    'Plata': 'Argento',
    'Silver': 'Argento',
    'Oro rosa': 'Oro rosa',
    'Rose gold': 'Oro rosa',
    'Enero': 'Gennaio',
    'January': 'Gennaio',
    'Febrero': 'Febbraio',
    'February': 'Febbraio',
    'Marzo': 'Marzo',
    'March': 'Marzo',
    'Abril': 'Aprile',
    'April': 'Aprile',
    'Mayo': 'Maggio',
    'May': 'Maggio',
    'Junio': 'Giugno',
    'June': 'Giugno',
    'Julio': 'Luglio',
    'July': 'Luglio',
    'Agosto': 'Agosto',
    'August': 'Agosto',
    'Septiembre': 'Settembre',
    'September': 'Settembre',
    'Octubre': 'Ottobre',
    'October': 'Ottobre',
    'Noviembre': 'Novembre',
    'November': 'Novembre',
    'Diciembre': 'Dicembre',
    'December': 'Dicembre',
    'Anillo Veria': 'ANELLO VERIA',
    'ANILLO VERIA': 'ANELLO VERIA',
    'VERIA RING': 'ANELLO VERIA',
    'Collar de Letra Bubble': 'COLLANA CON LETTERA BUBBLE',
    'COLLAR DE LETRA BUBBLE': 'COLLANA CON LETTERA BUBBLE',
    'BUBBLE LETTER NECKLACE': 'COLLANA CON LETTERA BUBBLE',
    'Pulsera Veria': 'BRACCIALE VERIA',
    'PULSERA VERIA': 'BRACCIALE VERIA',
    'VERIA BRACELET': 'BRACCIALE VERIA',
    'Collar Veria': 'COLLANA VERIA',
    'COLLAR VERIA': 'COLLANA VERIA',
    'VERIA NECKLACE': 'COLLANA VERIA',
    'Anillo Alma': 'ANELLO ALMA',
    'ANILLO ALMA': 'ANELLO ALMA',
    'ALMA RING': 'ANELLO ALMA',
    'Anillo Carla': 'ANELLO CARLA',
    'ANILLO CARLA': 'ANELLO CARLA',
    'CARLA RING': 'ANELLO CARLA',
    'Anillo Cloe': 'ANELLO CLOE',
    'ANILLO CLOE': 'ANELLO CLOE',
    'CLOE RING': 'ANELLO CLOE',
    'Pulsera Duo': 'BRACCIALE DUO',
    'PULSERA DUO': 'BRACCIALE DUO',
    'DUO BRACELET': 'BRACCIALE DUO',
    'Caja de regalo de lujo': 'Confezione regalo di lusso',
    'CAJA DE REGALO DE LUJO': 'Confezione regalo di lusso',
    'Luxury Gift Box': 'Confezione regalo di lusso'
  };

  const exactFrench = {
    'Color': 'Couleur',
    'Talla': 'Taille',
    'Size': 'Taille',
    'Número de letras': 'Nombre de lettres',
    'Number of letters': 'Nombre de lettres',
    'Número de piedras de nacimiento': 'Nombre de pierres de naissance',
    'Number of birthstones': 'Nombre de pierres de naissance',
    'Número de iniciales': 'Nombre d’initiales',
    'Number of initials': 'Nombre d’initiales',
    'Número de medallas': 'Nombre de pendentifs',
    'Number of Charms': 'Nombre de pendentifs',
    'Letra': 'Lettre',
    'Letter': 'Lettre',
    'Inicial': 'Initiale',
    'Initial': 'Initiale',
    'Medalla': 'Pendentif',
    'Charm': 'Pendentif',
    'Inicial izquierda': 'Initiale gauche',
    'Left initial': 'Initiale gauche',
    'Inicial derecha': 'Initiale droite',
    'Right initial': 'Initiale droite',
    'Piedra izquierda': 'Pierre de naissance gauche',
    'Piedra de nacimiento izquierda': 'Pierre de naissance gauche',
    'Left birthstone': 'Pierre de naissance gauche',
    'Piedra derecha': 'Pierre de naissance droite',
    'Piedra de nacimiento derecha': 'Pierre de naissance droite',
    'Right birthstone': 'Pierre de naissance droite',
    'Piedra de nacimiento': 'Pierre de naissance',
    'Birthstone': 'Pierre de naissance',
    'Oro': 'Or',
    'Gold': 'Or',
    'Plata': 'Argent',
    'Silver': 'Argent',
    'Oro rosa': 'Or rose',
    'Rose gold': 'Or rose',
    'Enero': 'Janvier',
    'January': 'Janvier',
    'Febrero': 'Février',
    'February': 'Février',
    'Marzo': 'Mars',
    'March': 'Mars',
    'Abril': 'Avril',
    'April': 'Avril',
    'Mayo': 'Mai',
    'May': 'Mai',
    'Junio': 'Juin',
    'June': 'Juin',
    'Julio': 'Juillet',
    'July': 'Juillet',
    'Agosto': 'Août',
    'August': 'Août',
    'Septiembre': 'Septembre',
    'September': 'Septembre',
    'Octubre': 'Octobre',
    'October': 'Octobre',
    'Noviembre': 'Novembre',
    'November': 'Novembre',
    'Diciembre': 'Décembre',
    'December': 'Décembre'
  };

  const extraLabels = {
    Size: ['Talla', 'Taille', 'Taglia', 'Size'],
    'Left birthstone': ['Piedra de nacimiento izquierda', 'Pierre de naissance gauche', 'Pietra di nascita sinistra', 'Left birthstone'],
    'Right birthstone': ['Piedra de nacimiento derecha', 'Pierre de naissance droite', 'Pietra di nascita destra', 'Right birthstone'],
    'Top initial': ['Inicial superior', 'Initiale du haut', 'Iniziale superiore', 'Top initial'],
    'Middle initial': ['Inicial central', 'Initiale centrale', 'Iniziale centrale', 'Middle initial'],
    'Bottom initial': ['Inicial inferior', 'Initiale du bas', 'Iniziale inferiore', 'Bottom initial'],
    'Number of charms': ['Número de charms', 'Nombre de pendentifs', 'Numero di ciondoli', 'Number of charms'],
    'Number of nameplates': ['Número de placas', 'Nombre de plaques', 'Numero di targhette', 'Number of nameplates'],
    'Number of birthstones': ['Número de piedras de nacimiento', 'Nombre de pierres de naissance', 'Numero di pietre di nascita', 'Number of birthstones'],
    'Number of letters': ['Número de letras', 'Nombre de lettres', 'Numero di lettere', 'Number of letters'],
    'Number of letters/birthstones': ['Número de letras/piedras', 'Nombre de lettres/pierres', 'Numero di lettere/pietre di nascita', 'Number of letters/birthstones'],
    'Name or word': ['Nombre o palabra', 'Nom ou mot', 'Nome o parola', 'Name or word'],
    Style: ['Estilo', 'Style', 'Stile', 'Style'],
    Engraving: ['Grabado', 'Gravure', 'Incisione', 'Engraving'],
    'Left engraving': ['Grabado izquierdo', 'Gravure gauche', 'Incisione sinistra', 'Left engraving'],
    'Right engraving': ['Grabado derecho', 'Gravure droite', 'Incisione destra', 'Right engraving'],
    January: ['Enero', 'Janvier', 'Gennaio', 'January'], February: ['Febrero', 'Février', 'Febbraio', 'February'],
    March: ['Marzo', 'Mars', 'Marzo', 'March'], April: ['Abril', 'Avril', 'Aprile', 'April'],
    May: ['Mayo', 'Mai', 'Maggio', 'May'], June: ['Junio', 'Juin', 'Giugno', 'June'],
    July: ['Julio', 'Juillet', 'Luglio', 'July'], August: ['Agosto', 'Août', 'Agosto', 'August'],
    September: ['Septiembre', 'Septembre', 'Settembre', 'September'], October: ['Octubre', 'Octobre', 'Ottobre', 'October'],
    November: ['Noviembre', 'Novembre', 'Novembre', 'November'], December: ['Diciembre', 'Décembre', 'Dicembre', 'December']
  };
  [exactSpanish, exactFrench, exactItalian, exactEnglish].forEach((dictionary, index) => {
    Object.entries(extraLabels).forEach(([key, values]) => { dictionary[key] = values[index]; });
    for (let n = 1; n <= 8; n += 1) {
      const names = [`Nombre en la placa ${n}`, `Nom sur la plaque ${n}`, `Nome sulla targhetta ${n}`, `Name on nameplate ${n}`];
      [`Nameplate ${n}`, `Name on nameplate ${n}`, `Nombre en la placa ${n}`].forEach(key => { dictionary[key] = names[index]; });
      const charms = [`Charm ${n}`, `Pendentif ${n}`, `Ciondolo ${n}`, `Charm ${n}`];
      [`Charm ${n}`, `Colgante ${n}`, `Medalla ${n}`].forEach(key => { dictionary[key] = charms[index]; });
      dictionary[`Charm ${n} initial`] = [`Inicial del charm ${n}`, `Initiale du pendentif ${n}`, `Iniziale del ciondolo ${n}`, `Charm ${n} initial`][index];
    }
  });

  const translate = (text) => {
    const value = text.trim();
    if (value.includes(' · ')) return value.split(' · ').map(translate).join(' · ');
    if (/^[SML] \(EU /.test(value)) return value.charAt(0);
    const colon = value.endsWith(':') ? ':' : '';
    const core = colon ? value.slice(0, -1).trim() : value;
    const isItalian = italianStorefront();
    const isFrench = frenchStorefront();
    const isSpanish = spanishStorefront();
    const exact = isItalian ? exactItalian : (isFrench ? exactFrench : (englishStorefront() ? exactEnglish : exactSpanish));
    let output = exact[core] || core;
    if (output === core) {
      output = isSpanish
        ? output
          .replace(/^(?:Letra\/piedra(?: de nacimiento)?|Letter\/birthstone) (\d+)$/i, 'Letra/piedra de nacimiento $1')
          .replace(/^(?:Piedra(?: de nacimiento)?|Birthstone) (\d+)$/i, 'Piedra de nacimiento $1')
          .replace(/^(?:Letra|Letter) (\d+)$/i, 'Letra $1')
          .replace(/^(?:Nombre en la placa|Name on nameplate) (\d+)$/i, 'Nombre en la placa $1')
          .replace(/^Bracelet (\d+) color and chain$/i, 'Color y modelo — pulsera $1')
          .replace(/^Bracelet (\d+) left engraving$/i, 'Grabado izquierdo — pulsera $1')
          .replace(/^Bracelet (\d+) right engraving$/i, 'Grabado derecho — pulsera $1')
          .replace(/Rose gold/gi, 'Oro rosa')
          .replace(/\bGold\b/gi, 'Oro')
          .replace(/\bSilver\b/gi, 'Plata')
          .replace(/fine chain/gi, 'eslabón fino')
          .replace(/wide chain/gi, 'eslabón ancho')
          .replace(/(\d+) letters?/gi, '$1 letras')
          .replace(/(\d+) birthstones?/gi, '$1 piedras de nacimiento')
          .replace(/\+(\$)(\d+)/g, (match, symbol, amount) => `+${amount}€`)
        : isItalian
        ? output
          .replace(/^(?:Letra\/piedra(?: de nacimiento)?|Letter\/birthstone) (\d+)$/i, 'Lettera/pietra di nascita $1')
          .replace(/^(?:Piedra(?: de nacimiento)?|Birthstone) (\d+)$/i, 'Pietra di nascita $1')
          .replace(/^(?:Letra|Letter) (\d+)$/i, 'Lettera $1')
          .replace(/^(?:Nombre de la placa|Nameplate) (\d+)$/i, 'Targhetta $1')
          .replace(/^Bracelet (\d+) color and chain$/i, 'Colore e modello — bracciale $1')
          .replace(/^Bracelet (\d+) left engraving$/i, 'Incisione sinistra — bracciale $1')
          .replace(/^Bracelet (\d+) right engraving$/i, 'Incisione destra — bracciale $1')
          .replace(/^Color y modelo — pulsera (\d+)$/i, 'Colore e modello — bracciale $1')
          .replace(/^Grabado izquierda — pulsera (\d+)$/i, 'Incisione sinistra — bracciale $1')
          .replace(/^Grabado derecha — pulsera (\d+)$/i, 'Incisione destra — bracciale $1')
          .replace(/Oro rosa/gi, 'Oro rosa')
          .replace(/\bGold\b/gi, 'Oro')
          .replace(/\b(?:Plata|Silver)\b/gi, 'Argento')
          .replace(/(?:eslabón|maglia) fino/gi, 'maglia fine')
          .replace(/(?:eslabón|maglia) ancho/gi, 'maglia larga')
          .replace(/fine chain/gi, 'maglia fine')
          .replace(/wide chain/gi, 'maglia larga')
          .replace(/(\d+) (?:letras?|letters?)\b/gi, (match, count) => `${count} ${count === '1' ? 'lettera' : 'lettere'}`)
          .replace(/(\d+) (?:piedras? de nacimiento|birthstones?)/gi, (match, count) => `${count} ${count === '1' ? 'pietra di nascita' : 'pietre di nascita'}`)
          .replace(/(\d+) (?:medallas?|charms?)/gi, (match, count) => `${count} ${count === '1' ? 'ciondolo' : 'ciondoli'}`)
        : isFrench
          ? output
            .replace(/^(?:Letra\/piedra(?: de nacimiento)?|Letter\/birthstone) (\d+)$/i, 'Lettre/pierre de naissance $1')
            .replace(/^(?:Piedra(?: de nacimiento)?|Birthstone) (\d+)$/i, 'Pierre de naissance $1')
            .replace(/^(?:Letra|Letter) (\d+)$/i, 'Lettre $1')
            .replace(/^(?:Nombre en la placa|Name on nameplate) (\d+)$/i, 'Nom sur la plaque $1')
            .replace(/^Bracelet (\d+) color and chain$/i, 'Couleur et modèle — bracelet $1')
            .replace(/^Bracelet (\d+) left engraving$/i, 'Gravure gauche — bracelet $1')
            .replace(/^Bracelet (\d+) right engraving$/i, 'Gravure droite — bracelet $1')
            .replace(/^Color y modelo — pulsera (\d+)$/i, 'Couleur et modèle — bracelet $1')
            .replace(/^Grabado izquierd[oa] — pulsera (\d+)$/i, 'Gravure gauche — bracelet $1')
            .replace(/^Grabado derech[oa] — pulsera (\d+)$/i, 'Gravure droite — bracelet $1')
            .replace(/Oro rosa|Rose gold/gi, 'Or rose')
            .replace(/\bGold\b|\bOro\b/gi, 'Or')
            .replace(/\b(?:Plata|Silver|Argento)\b/gi, 'Argent')
            .replace(/eslabón fino|fine chain/gi, 'maille fine')
            .replace(/eslabón ancho|wide chain/gi, 'maille large')
            .replace(/(\d+) (?:letras?|letters?)\b/gi, (match, count) => `${count} ${count === '1' ? 'lettre' : 'lettres'}`)
            .replace(/(\d+) (?:piedras? de nacimiento|birthstones?)/gi, (match, count) => `${count} ${count === '1' ? 'pierre de naissance' : 'pierres de naissance'}`)
            .replace(/(\d+) (?:medallas?|charms?)/gi, (match, count) => `${count} ${count === '1' ? 'pendentif' : 'pendentifs'}`)
          : output
          .replace(/Oro rosa/gi, 'Rose gold')
          .replace(/\bOro\b/gi, 'Gold')
          .replace(/\bPlata\b/gi, 'Silver')
          .replace(/eslabón fino/gi, 'fine chain')
          .replace(/eslabón ancho/gi, 'wide chain')
          .replace(/(\d+) letras?/gi, '$1 letters')
          .replace(/(\d+) piedras? de nacimiento/gi, '$1 birthstones')
          .replace(/\+(\d+)€/g, (match, amount) => `+$${amount}`);
    }
    return output + colon;
  };

  const localizeDrawer = () => {
    if (!englishStorefront() && !frenchStorefront() && !italianStorefront() && !spanishStorefront()) return;
    const elements = [
      ...document.querySelectorAll('#CartDrawer .product-option dt, #CartDrawer .product-option dd, #CartDrawer .cart-item__name'),
      ...[...document.querySelectorAll('#CartDrawer .product-option')].filter((element) => !element.querySelector('dt, dd'))
    ];

    elements.forEach((element) => {
      if (element.hasAttribute('data-mv-preserve-value')) return;
      const translated = translate(element.textContent || '');
      if (translated !== (element.textContent || '').trim()) element.textContent = translated;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    localizeDrawer();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observerOptions = { childList: true, subtree: true };
      const observer = new MutationObserver(() => {
        // Our own text updates must not trigger another localization pass.
        // Reconnect afterwards so later cart updates are still translated.
        observer.disconnect();
        try {
          localizeDrawer();
        } finally {
          observer.observe(drawer, observerOptions);
        }
      });
      observer.observe(drawer, observerOptions);
    }
  });
})();
